import React from 'react';

import { Box } from '@mui/material';
import ProgressWithLabel from 'components/ProgressWithLabel';

import { IBookWithProgress } from '@common/models/Books/Book';

import ProgressChip from '../ProgressChip';
import {
	BookItemImg,
	BookItemInfoSubTitle,
	BookItemInfoTitle,
	BookItemInfoWrap,
	BookItemLink,
	BookItemWrap,
} from './style';

interface PropsType {
	book: IBookWithProgress;
}

function BookItem({ book }: PropsType) {
	const progressInNumbers = Number.isNaN(Number(book.progress)) ? 0 : Number(book.progress);

	return (
		<BookItemLink target="_blank" href={book.pdf_url}>
			<BookItemWrap>
				<BookItemImg src={book.image_url} alt="Book" />
				<BookItemInfoWrap>
					<Box>
						<BookItemInfoTitle lineClamp={{ xs: 3 }} variant="subtitle1">
							{book.name}
						</BookItemInfoTitle>
						{book.author && (
							<BookItemInfoSubTitle variant="body3" textColor="secondary" lineClamp={{ xs: 3 }}>
								{book.author}
							</BookItemInfoSubTitle>
						)}
					</Box>
					<ProgressChip progress={progressInNumbers} />
					<Box marginTop="auto">
						<ProgressWithLabel value={progressInNumbers} />
					</Box>
				</BookItemInfoWrap>
			</BookItemWrap>
		</BookItemLink>
	);
}

export default BookItem;
